import React from 'react';
import styled, { css } from 'styled-components';
import { redColor } from 'js/config/style';

const doesNotHaveValue = css`
  font-weight: 500;
`;

const errorDisplay = css`
  color: ${redColor};
`;

const Text = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${({ bold }) => (bold ? '700' : 'normal')};
  margin-bottom: ${({ bold }) => (bold ? '0.5rem' : '0')};
  ${({ hasValue }) => hasValue === false && doesNotHaveValue}
  ${({ hasValue, required }) => hasValue === false && required && errorDisplay};
`;

export default props => (props.hasValue === false ? <Text {...props}>Unknown</Text> : <Text {...props} />);
